import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useHistory, useLocation } from "react-router-dom";

import { useMatomo } from "@datapunt/matomo-tracker-react";

import APIs from "../../APIs";
import _ from "lodash";

import { makeStyles } from "@material-ui/styles";
import { fade, Typography, Grid, List, Button } from "@material-ui/core";

import { useDocTitle } from "../../components/_common/DocTitle";
import Preloader from "../../components/_common/Preloader";
import RSIGESTORZYsearchGestor from "./RSIGESTORZY_SearchGestor";
import GestorzyAccordion from "./GestorzyAccordion";
import { generatePDF } from "../../components/Report/functions";
import ReportTMPL from "../../components/Report/TMPL";

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const regex = /(<([^>]+)>)|\t|\n|&nbsp;/gi;

const useStyles = makeStyles((theme) => ({
    bigTitle: {
        margin: theme.spacing(0, 4, 4, 4),
        textAlign: "center",
        justifyContent: "center",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.125rem",
            fontWeight: theme.typography.fontWeightMedium,
        },
    },
    alphabet: {
        display: "flex",
        justifyContent: "space-between",
        overflow: "hidden",
    },
    listOverlay: {
        content: '""',
        position: "absolute",
        width: "100%",
        height: 1,
        bottom: -1,
        boxShadow: `0 1px 56px 64px ${theme.palette.background.paper}`,
        zIndex: 1,
    },
    listRoot: {
        maxHeight: "calc(100vh - 0px)",
        overflow: "hidden",
        overflowY: "scroll",
        marginTop: theme.spacing(4),
        paddingBottom: "100vh",
        position: "relative",
        scrollBehavior: "smooth",
    },
    listSection: {
        backgroundColor: "inherit",
    },
    ul: {
        backgroundColor: "inherit",
        padding: 0,
    },
    listSubheaderSticky: {
        backgroundColor: "rgb(234 237 244)",
        color: theme.palette.primary.main,
        padding: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            lineHeight: 1.4,
            fontWeight: theme.typography.fontWeightRegular,
        },
    },
    listItemSelected: {
        backgroundColor: `${fade(theme.palette.primary.main, 0.25)}!important`,
    },
    alphabetChip: {
        backgroundColor: fade(theme.palette.primary.light, 0.5),
        color: theme.palette.primary.contrastText,
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
        },
        "&:focus": {
            backgroundColor: theme.palette.primary.main,
        },
    },
    alphabetChipAcvtive: {
        backgroundColor: theme.palette.primary.main,
    },
    alphabetAvatar: {
        backgroundColor: theme.palette.primary.main,
    },
    listItemAvatarAvatar: {
        backgroundColor: fade(theme.palette.primary.main, 0.25),
    },
    formControl: {
        marginTop: theme.spacing(2),
        minWidth: "100%",
    },
    preRender: {
        position: "fixed",
        left: 0,
        right: "200vw",
        top: "200vh",
        width: "210mm",
    },

    pdfLoadingWrapper: {
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "rgba(255,255,255,0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
    },
    btnReport: {
        margin: "16px 8px",
        height: 40,
        minWidth: 150,
        [theme.breakpoints.down("sm")]: {
            margin: theme.spacing(4, 0, 4, 2),
        },
    },
}));

const RSIGESTORZY_Page = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const query = useQuery();

    useDocTitle(t("pages.issuers"));

    const [gestorzy, setGestorzy] = useState([]);
    const [data, setData] = useState([]);
    const [loadingPdf, setLoadingPDF] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [report, setReport] = useState(false);
    const [checked, setChecked] = useState([]);
    const [reportData, setReportData] = useState([]);

    useEffect(
        () => {
            let apiURL = `${APIs.dataURL.rsigestorzy}${history.location.search}`;

            if (location.pathname.split("/").length === 3) {
                apiURL = `${APIs.dataURL.rsigestorzy}?nazwa=&typ=${location.pathname
                    .split("/")[2]
                    .split("_")
                    .join("+")}`;
                if (data.length) return;
            } else {
                if (query.get("typ"))
                    window.location.hash = `#${location.pathname}/${query.get("typ").split(" ").join("_")}`;
            }

            axios.get(apiURL).then((result) => {
                const gestor_levels = {
                    "Administracja terenowa": {
                        name: "Administracja terenowa",
                        level: 3,
                    },
                    "Pozostała administracja centralna": {
                        name: "Pozostała administracja centralna",
                        level: 2,
                    },
                    Ministerstwo: {
                        name: "Ministerstwo",
                        level: 1,
                    },
                };

                const apiData = result.data.results
                    .map((item) => {
                        item.nazwa = item.nazwa.replace(regex, "");
                        item.systemy = item.systemy
                            .map((system) => ({
                                ...system,
                                gestor_level: gestor_levels[item.typ]?.level,
                                nazwa_systemu: system.nazwa_systemu.replace(regex, ""),
                                nazwa_systemu_skr: system.nazwa_systemu_skr
                                    ? system.nazwa_systemu_skr.replace(regex, "")
                                    : "",
                            }))
                            .sort((a, b) => a.nazwa_systemu.toUpperCase().localeCompare(b.nazwa_systemu.toUpperCase()));
                        return {
                            ...item,
                            gestor_level: gestor_levels[item.typ]?.level,
                        };
                    })
                    .sort((a, b) => a.nazwa.toUpperCase().localeCompare(b.nazwa.toUpperCase()));

                setData(apiData);
                setGestorzy(apiData.map((d) => ({ title: d.nazwa, id: d.id_gestor, typ: d.typ })));
            });
        },
        // eslint-disable-next-line
        [location]
    );

    const handleSearchGestorClick = ({ itemId, firstLetter }) => {
        const anchor = document.querySelector(`#sub-${itemId}`);
        const aList = document.querySelector(`#aList`);

        if (anchor) {
            let topPos = anchor.offsetTop;
            aList.scrollTop = topPos;
        }
    };

    const handleSearchInputChange = (args) => {
        setSearchText(args);
    };

    const handleChecked = (item) => {
        let newChecked = [];

        if (item.length) {
            newChecked =
                checked.filter((c) => c.gestor_id === item[0].gestor_id).length &&
                checked.filter((c) => c.gestor_id === item[0].gestor_id).length === item.length
                    ? checked.filter((c) => c.gestor_id !== item[0].gestor_id)
                    : [...checked.filter((c) => c.gestor_id !== item[0].gestor_id), ...item];
        } else {
            newChecked = checked.find((c) => c.id_systemu === item.id_systemu)
                ? checked.filter((c) => c.id_systemu !== item.id_systemu)
                : [...checked, item];
        }
        setChecked(newChecked);
    };

    const handleGetReport = () => {
        report && setChecked([]);
        setReport(!report);
        if (!checked.length) return;
        console.log("Get report: ", checked);
        exportPdf({
            abouts: checked,
        });
    };

    const exportPdf = async (PDFOptions) => {
        const selectedData = _.orderBy(checked, ["gestor_level", "nazwa_systemu"], ["asc", "asc"]);

        let pdfData = [];

        setLoadingPDF(true);

        selectedData.forEach((item) => {
            axios
                .get(`${APIs.dataURL.rsisystemy}/${item.id_systemu}`)
                .then((result) => {
                    pdfData.push({
                        ...item,
                        ...result.data,
                    });
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    if (selectedData.length === pdfData.length) {
                        setReportData(
                            pdfData.sort(
                                (a, b) =>
                                    a.gestor_level - b.gestor_level || a.nazwa_systemu.localeCompare(b.nazwa_systemu)
                            )
                        );

                        setTimeout(() => {
                            generatePDF({
                                data: pdfData.sort(
                                    (a, b) =>
                                        a.gestor_level - b.gestor_level ||
                                        a.nazwa_systemu.localeCompare(b.nazwa_systemu)
                                ),
                            });
                            setLoadingPDF(false);
                        }, 1234);
                    }
                });
        });
        return;
    };

    // Track page view
    const { trackPageView } = useMatomo();
    React.useEffect(() => {
        trackPageView();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <Typography variant="h4" className={classes.bigTitle} color="primary">
                {t("pages.issuers")}
            </Typography>

            {!!loadingPdf && (
                <div className={classes.pdfLoadingWrapper}>
                    <img src={"/images/preloader833.gif"} style={{ width: 128 }} alt={"Loading..."} />
                </div>
            )}

            {!!reportData.length && (
                <div className={classes.preRender}>
                    <ReportTMPL reportData={reportData} />
                </div>
            )}

            <Grid container>
                <Grid item xs={12} md={12} style={{ display: "flex" }}>
                    <RSIGESTORZYsearchGestor
                        dataSet={gestorzy}
                        onSelect={(args) => handleSearchGestorClick(args)}
                        onInputChange={(args) => handleSearchInputChange(args)}
                    />
                    <Button
                        variant={"contained"}
                        color={"primary"}
                        className={classes.btnReport}
                        onClick={handleGetReport}
                    >
                        {checked.length ? "Pobierz raport" : "Raport"}
                    </Button>
                </Grid>
                <Grid item xs={12} style={{ position: "relative", overflow: "hidden" }} id="aGrid">
                    <div className={classes.listOverlay0} />
                    <List className={classes.listRoot0} dense={true} subheader={<li />} id="aList">
                        <div id="sub-startOfList" />
                        <div id="item-startOfList" />
                        {data.length && gestorzy.length ? (
                            gestorzy
                                .filter((d) =>
                                    props.match.params.id
                                        ? d.typ.toUpperCase() === props.match.params.id.toUpperCase() ||
                                          d.typ.toUpperCase() ===
                                              props.match.params.id.split("_").join(" ").toUpperCase()
                                        : d
                                )
                                .filter((d) =>
                                    searchText ? d.title.toUpperCase().includes(searchText.toUpperCase()) : d
                                )
                                .map((gestor) => {
                                    return (
                                        <div key={`gestor-${gestor.id}`}>
                                            <GestorzyAccordion
                                                gestor={gestor}
                                                data={
                                                    data.find((d) => d.nazwa === gestor.title)
                                                        ? data
                                                              .find((d) => d.nazwa === gestor.title)
                                                              .systemy.map((s) => ({ ...s, gestor_id: gestor.id }))
                                                        : []
                                                }
                                                checked={checked}
                                                onChecked={(item) => handleChecked(item)}
                                                report={report}
                                            />
                                        </div>
                                    );
                                })
                        ) : (
                            <>
                                <Preloader type="linear" />
                                <Preloader type="linear" />
                                <Preloader type="linear" />
                            </>
                        )}
                    </List>
                </Grid>
            </Grid>
        </>
    );
};

export default RSIGESTORZY_Page;
